import script from "./SitePasswordGate.vue?vue&type=script&setup=true&lang=js"
export * from "./SitePasswordGate.vue?vue&type=script&setup=true&lang=js"

import "./SitePasswordGate.vue?vue&type=style&index=0&id=1c0fde52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c0fde52"]])

export default __exports__